import { contactInfo, hours } from "@/mocks/homeData";

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-foreground-200 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <div className="bg-white/10 rounded-md px-3 py-2 inline-block mb-4">
              <span className="text-xl font-bold text-white font-heading tracking-wide">
                MOBICAR PRO
              </span>
            </div>
            <p className="text-sm text-foreground-300 italic mb-4">
              « La mécanique faite avec passion »
            </p>
            <p className="text-sm text-foreground-400">
              Garage automobile au Tampon. Diagnostic, entretien et réparation de
              véhicules.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4 font-heading">
              Contact
            </h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center mt-0.5 text-foreground-400" />
                <span>
                  {contactInfo.address}
                  <br />
                  {contactInfo.city}
                </span>
              </div>
              <a
                href={contactInfo.phoneHref}
                className="flex items-center gap-2 hover:text-primary-400 transition-colors"
              >
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center text-foreground-400" />
                {contactInfo.phone}
              </a>
              <a
                href={contactInfo.emailHref}
                className="flex items-center gap-2 hover:text-primary-400 transition-colors"
              >
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center text-foreground-400" />
                {contactInfo.email}
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4 font-heading">
              Horaires
            </h3>
            <div className="space-y-1 text-sm text-foreground-300 mb-6">
              <div className="flex items-center gap-2">
                <i className="ri-time-line w-4 h-4 flex items-center justify-center text-foreground-400" />
                <span>
                  Lundi – Vendredi : 8 h–12 h / 14 h–17 h
                </span>
              </div>
              <p className="pl-6">Samedi – Dimanche : fermé</p>
            </div>

            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-3 font-heading">
              Informations légales
            </h3>
            <div className="space-y-2 text-sm">
              <a
                href="/mentions-legales"
                className="block hover:text-primary-400 transition-colors"
              >
                Mentions légales
              </a>
              <a
                href="/politique-de-confidentialite"
                className="block hover:text-primary-400 transition-colors"
              >
                Politique de confidentialité
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-10 pt-8 text-center text-xs text-foreground-500">
          <p>© 2026 Mobicar Pro. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}